// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import SwitcherTwoToneSvg from "@ant-design/icons-svg/es/asn/SwitcherTwoTone";
import AntdIcon from '../components/AntdIcon';

var SwitcherTwoTone = function SwitcherTwoTone(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: SwitcherTwoToneSvg
  }));
};

SwitcherTwoTone.displayName = 'SwitcherTwoTone';
export default React.forwardRef(SwitcherTwoTone);


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@ant-design_icons@4.0.6@@ant-design/icons/es/icons/SwitcherTwoTone.js
// module id = 1899
// module chunks = 0